export default __webpack_public_path__ + "static/media/Fresh.2d79b71a.png";